import { BaseModel } from './base';

export enum DiscountAmountType {
  fixed = 0,
  percentage = 1,
}

export const DiscountAmountTypeLabels: Record<DiscountAmountType, string> = {
  [DiscountAmountType.fixed]: 'general.fixed',
  [DiscountAmountType.percentage]: 'general.percentage',
};

export enum DiscountTaxType {
  post = 0,
  pre = 1,
}

export const DiscountTaxTypeLabels: Record<DiscountTaxType, string> = {
  [DiscountTaxType.post]: 'general.post',
  [DiscountTaxType.pre]: 'general.pre',
};

export class DiscountModel extends BaseModel {
  idDiscountModel!: number;
  name!: string;
  amount!: number;
  amountType!: DiscountAmountType;
  discountTaxType!: DiscountTaxType;

  override objectID(): string | null {
    return this.idDiscountModel?.toString() ?? null;
  }

  get isAmountTypeFixed(): boolean {
    return this.amountType === DiscountAmountType.fixed;
  }

  get isAmountTypePercentage(): boolean {
    return this.amountType === DiscountAmountType.percentage;
  }
}
